import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { get, del } from "@utils/axios_api";

const fetchReferenceList = async (params) => {
    const response = await get("/admin/ref/referenceList", { params });
    return response;
};
export function useReference(queryParam) {
  const [selectedItems, setSelectedItems] = useState([]);


  const { data, refetch } = useQuery({
    queryKey: ["selectReferenceList", queryParam],
    queryFn: () => fetchReferenceList(queryParam),
    keepPreviousData: true,
  });

  const handleSelectAll = (checked) => {
    if (!data || !data.resultList) return;
    if (checked) {
      const allIds = data.resultList.map((item) => item.referenceId);
      setSelectedItems(allIds);
    } else {
      setSelectedItems([]);
    }
  };

  const handleSelectItem = (id) => {
    
    if (selectedItems.includes(id)) {
      setSelectedItems(selectedItems.filter((x) => x !== id));
    } else {
      setSelectedItems([...selectedItems, id]);
    }
  };

  const referenceDelete = async () => {
    if (!selectedItems.length) {
      alert("삭제할 항목을 선택해주세요.");
      return;
    }

    const isConfirmed = window.confirm("영구적으로 삭제 됩니다. 정말 삭제하시겠습니까? ");
    if (!isConfirmed) return;
    
    try {
      const response = await del("/admin/ref/referenceDelete", {
        data: {
          idlist: selectedItems,
        },
      });
      alert(response?.message);
      refetch(); 
      setSelectedItems([]); 
    } catch (err) {
      console.error(err);
      alert("삭제 실패");
    }
  };



  const isAllChecked = !!(data?.resultList?.length && selectedItems.length === data?.resultList?.length);

  return { data, refetch, selectedItems, isAllChecked,  handleSelectAll, handleSelectItem, referenceDelete };
}
